<template>
  <ActionPopover :show="show" @hide="$emit('hide')">
    <ul class="keyword-planner-action-list">
      <li class="keyword-planner-action-list__item">
        <span
          class="keyword-planner-action-list__item-content"
          @click="showAddKeyword"
        >
          <i class="el-icon-plus keyword-planner-action-list__item-icon" />
          {{ $t('ADVERTISEMENT.ADD_TO_KEYWORDS') }}
        </span>
      </li>
      <li class="keyword-planner-action-list__item">
        <span
          class="keyword-planner-action-list__item-content"
          @click="showNegative"
        >
          <i
            class="
            el-icon-remove-outline
            keyword-planner-action-list__item-icon
          "
          />
          {{ $t('ADVERTISEMENT.ADD_TO_NEGATIVE_KEYWORDS') }}
        </span>
      </li>
    </ul>
  </ActionPopover>
</template>

<script>
import { keywordPlannerActions } from './common/constants';
import {
  AD_KEYWORD_PLANNER_ADD_TO_KEYWORD_ROW_BUTTON,
  AD_KEYWORD_PLANNER_ADD_TO_NEGATIVE_KEYWORD_ROW_BUTTON,
} from '@/constants/gtm-events';
import ActionPopover from '../../../../common/ActionPopover';

export default {
  name: 'KeywordPlannerActionList',
  components: {
    ActionPopover,
  },
  props: {
    show: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    showAddKeyword() {
      this.$gtm.trackEvent(AD_KEYWORD_PLANNER_ADD_TO_KEYWORD_ROW_BUTTON);

      this.emitAction(keywordPlannerActions.ADD_KEYWORD);
    },
    showNegative() {
      this.$gtm.trackEvent(
        AD_KEYWORD_PLANNER_ADD_TO_NEGATIVE_KEYWORD_ROW_BUTTON,
      );

      this.emitAction(keywordPlannerActions.ADD_NEGATIVE);
    },
    emitAction(action) {
      this.$emit('select', action);
    },
  },
};
</script>

<style lang="scss">
.keyword-planner-action-list {
  margin: 0;
  list-style-type: none;
  color: $lb-black;
  width: rem-calc(320px);

  padding: 0 $global-padding;

  font-size: 13px;

  &__item {
    padding: $global-padding * 0.8 0;

    display: flex;
    align-items: center;

    &-content {
      cursor: pointer;
      transition-duration: 0.3s;

      &:hover {
        color: $lb-color-primary;
      }
    }

    &-icon {
      color: #c0c4cc;

      margin-left: $global-margin * 0.625;
    }

    &:not(:last-child) {
      border-bottom: 1px dashed #dfdfdf;
    }
  }
}
</style>
